module.exports = __webpack_public_path__ + "img/km.babaabe1.svg";